export default "__VITE_ASSET__Dmd1LZJ4__"